export const DELETE_PROJECT_CONFIRMATION =
    "Are you sure you want to delete this project? \n\n" +
    "This will also delete all tasks associated with it. This action cannot be undone. \n\n" +
    " If you want to keep your tasks, please re-assign tasks to a different project first";
export const ARCHIVE_PROJECT_CONFIRMATION =
    "Are you sure you want to archive this project? \n\n" +
    "All project data will remain saved, but the project will not be accessible for now";
